export function formatCentsToDollars(cents) {
  const num = Number(cents);
  if (!isFinite(num) || num < 0) {
    return { integer: "0", fraction: "00" };
  }
  const value = (num / 100).toFixed(2);
  const [integer, fraction] = value.split(".");
  return { integer, fraction };
}
